var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgNewAssetValue = function SvgNewAssetValue(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.536,
    height: 19.996,
    viewBox: "0 0 20.536 19.996",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69878",
    "data-name": "Group 69878",
    transform: "translate(-2.999 -3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34273",
    "data-name": "Path 34273",
    d: "M3.113,9.67a.769.769,0,0,1,.251-1.058l9-5.5a.769.769,0,0,1,.807,0l9.251,5.5a.769.769,0,0,1-.807,1.31l-1.156-.517v1.286a.769.769,0,0,1-1.538,0V8.458L12.767,4.672,6.614,8.458v8.385H9.691V10.691a.769.769,0,0,1,.769-.769h4.615a.769.769,0,0,1,.769.769v.769a.769.769,0,1,1-1.538,0H11.229v5.384a.769.769,0,1,1,0,1.538H5.845a.769.769,0,0,1-.769-.769V9.405l-.905.517A.769.769,0,0,1,3.113,9.67Z",
    transform: "translate(0)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34274",
    "data-name": "Path 34274",
    d: "M21.384,15a5.384,5.384,0,1,0,5.384,5.384A5.39,5.39,0,0,0,21.384,15Zm0,9.229a3.845,3.845,0,1,1,3.845-3.845A3.85,3.85,0,0,1,21.384,24.229Z",
    transform: "translate(-3.233 -2.771)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34275",
    "data-name": "Path 34275",
    d: "M23.076,18.769v2.307a.77.77,0,0,1-.425.688l-1.538.769a.769.769,0,1,1-.688-1.376l1.114-.557V18.769a.769.769,0,1,1,1.538,0Z",
    transform: "translate(-4.156 -3.463)",
    fill: "#ffd45d"
  }))));
};

export default SvgNewAssetValue;